var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "information_icon",
    "data-name": "information icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.793,
    height: 23.793,
    viewBox: "0 0 23.793 23.793",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27040",
    "data-name": "Group 27040",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3045",
    "data-name": "Ellipse 3045",
    cx: 11.896,
    cy: 11.896,
    r: 11.896,
    fill: "#4972f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35592",
    "data-name": "Path 35592",
    d: "M8.453,5.663a1.261,1.261,0,0,1-.914-.369,1.215,1.215,0,0,1-.379-.9,1.24,1.24,0,0,1,.388-.9,1.24,1.24,0,0,1,.9-.388,1.261,1.261,0,0,1,.923.388,1.24,1.24,0,0,1,.388.9,1.215,1.215,0,0,1-.379.9A1.284,1.284,0,0,1,8.453,5.663ZM9.5,7.546V16.8H7.419V7.546Z",
    transform: "translate(3.435 1.95)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.1450c7b1ba51dabe844ed5f0aec8b830.svg";
export { ForwardRef as ReactComponent };